import { ADD_PATH, SAVE_FILTERS } from "./modules/constants";

// URLs for filter preservation
export const timesheetUrls = [
  "/user/timesheet/daily",
  "/user/timesheet/bi-weekly",
  "/user/timesheet/monthly",
  "/user/timesheet/custom-range",
  "/user/timesheet/weekly",
  "/user/timesheet/approval",
];

export const trackingUrls = ["/user/reports/route-map"];

// Initial State
const initialState = {
  filters: null,
  paths: [],
};

export const timesheetActivityGroupUrls = [...timesheetUrls, ...trackingUrls];

// Action Handlers
export const handleSetFilters = (state, action) => {
  return {
    ...state,
    filters: action?.payload,
  };
};

export const handleAddPath = (state, action) => {
  const pathName = action?.payload?.split("?")[0];
  const newPaths = [pathName, ...state.paths];
  if (newPaths.length > 3) {
    newPaths.pop();
  }
  let filters = state.filters;
  if (state.filters?.pathname) {
    if (state.filters?.pathname === "/user/customers") {
      if (
        ![
          "/user/customers",
          "/user/add-customer",
          "/user/edit-customer",
          "/user/customer-details",
        ].includes(pathName)
      ) {
        filters = null;
      }
    }
    if (state.filters?.pathname === "/user/members") {
      if (
        ![
          "/user/members",
          "/user/member-details",
          "/user/member-invitation",
        ].includes(pathName)
      ) {
        filters = null;
      }
    }
    if (state.filters?.pathname === "/user/invoices") {
      if (
        ![
          "/user/invoices",
          "/user/edit-invoice",
          "/user/invoice-preview",
          "/user/invoice-client-view",
          "/user/create-invoice",
        ].includes(pathName)
      ) {
        filters = null;
      }
    }
    if (state.filters?.pathname === "/user/project") {
      if (
        ![
          "/user/create-project",
          "/user/project",
          "/user/edit-project",
          "/user/details-project",
        ].includes(pathName)
      ) {
        filters = null;
      }
    }
    if (state.filters?.pathname === "/user/job") {
      if (
        ![
          "/user/create-job",
          "/user/job",
          "/user/edit-job",
          "/user/details-job",
        ].includes(pathName)
      ) {
        filters = null;
      }
    }
    if (state.filters?.pathname === "/user/teams") {
      if (
        !["/user/add-team", "/user/team-details", "/user/teams"].includes(
          pathName,
        )
      ) {
        filters = null;
      }
    }
    if (state.filters?.pathname === "/user/tasks") {
      if (
        !["/user/create-task", "/user/task-details", "/user/tasks"].includes(
          pathName,
        )
      ) {
        filters = null;
      }
    }
    if (state.filters?.pathname === "/user/jobs") {
      if (
        !["/user/create-job", "/user/job-details", "/user/jobs"].includes(
          pathName,
        )
      ) {
        filters = null;
      }
    }
    if ([...timesheetUrls, ...trackingUrls].includes(state.filters?.pathname)) {
      if (![...timesheetUrls, ...trackingUrls].includes(pathName)) {
        filters = null;
      }
    }
  }

  return {
    ...state,
    filters,
    paths: newPaths,
  };
};

// Reducer
const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_FILTERS:
      return handleSetFilters(state, action);
    case ADD_PATH:
      return handleAddPath(state, action);
    default:
      return state;
  }
};

export const setPathName = pathName => ({
  type: SAVE_FILTERS,
  payload: pathName,
});

export const addPath = path => ({
  type: ADD_PATH,
  payload: path,
});

export default filterReducer;
